module.exports = __webpack_public_path__ + "media/images/front/medicines/ico_accordion-arrow-25db848a81ba93eb7a495b0a9bd0fdc5.svg";